<template>
  <div class="bottom-content">
    <div class="pc_bottom-container" v-if="isMaxScreen">
      <div class="bottom-arrow-box" v-if="showArrow">
        <img src="../../assets/image/eu-home/bottom-arrow.png" alt="" class="bottom-arrow-icon" />
      </div>
      <div class="bottom-content-box">
        <div class="bottom-content">
          <div class="bottom-content-item">
            <div class="bottom-content-row">
              <!-- <img
                src="../../assets/image/eu-home/icon/subtract.png"
                alt=""
                class="subtract-icon"
              />
              <img src="../../assets/image/eu-home/icon/eSwop.png" alt="" class="eSwop-icon" /> -->
              <img src="../../assets/image/eu-home/icon/danghuan-logo.png" alt="" class="danghuan-logo">
            </div>
          </div>
          <div class="bottom-content-item">
            <div class="bottom-content-row-box" v-for="row in bottomIconList" :key="row.title">
              <div class="bottom-content-row-title">{{ row.title }}</div>
              <div class="bottom-content-row">
                <div
                  v-for="(item, i) in row.icons"
                  :key="i"
                  @click="handleJumpToPage(item.url)"
                  :class="item.boxClass"
                >
                  <img :src="item.icon" alt="" :class="item.iconClass" />
                </div>
              </div>
            </div>
          </div>
          <div class="bottom-content-item">
            <div
              v-for="item in bottomDomList"
              :key="item.url"
              @click="handleJumpToPage(item.url)"
              class="bottom-content-row-dom-text"
            >
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-container" v-else>
      <div class="bottom-content-box">
        <div class="bottom-content-item">
          <div class="bottom-content-row">
            <!-- <img src="../../assets/image/eu-home/icon/subtract.png" alt="" class="subtract-icon" />
            <img src="../../assets/image/eu-home/icon/eSwop.png" alt="" class="eSwop-icon" /> -->
            <img src="../../assets/image/eu-home/icon/danghuan-logo.png" alt="" class="danghuan-logo">
          </div>
        </div>
        <div class="bottom-content-item">
          <div class="bottom-content-row-box" v-for="row in bottomIconList" :key="row.title">
            <div class="bottom-content-row-title">{{ row.title }}</div>
            <div class="bottom-content-row">
              <div
                v-for="(item, i) in row.icons"
                :key="i"
                @click="handleJumpToPage(item.url)"
                :class="item.boxClass"
              >
                <img :src="item.icon" alt="" :class="item.iconClass" />
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-content-item">
          <div
            v-for="item in bottomDomList"
            :key="item.text"
            @click="handleJumpToPage(item.url)"
            class="bottom-content-row-dom-text"
          >
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: { 
    showArrow: {
      type: Boolean,
      default: true
    }
  },
  components: {},
  data() {
    return {
      bottomIconList: [
        {
          title: this.$t('bottom.index.646d51qugz40'),
          icons: [
            // {
            //   icon: require('../../assets/image/eu-home/facebook.png'),
            //   boxClass: 'row1-box',
            //   iconClass: 'row1-icon',
            //   url: ''
            // },
            {
              icon: require('../../assets/image/eu-home/ins.png'),
              boxClass: 'row1-box',
              iconClass: 'row1-icon',
              url: 'https://www.linkedin.com/company/eswopeurope/?viewAsMember=true'
            },
            {
              icon: require('../../assets/image/eu-home/x.png'),
              boxClass: 'row1-box',
              iconClass: 'row1-icon',
              url: 'https://x.com/eSwop_EU'
            },
            {
              icon: require('../../assets/image/eu-home/lingying.png'),
              boxClass: 'row1-box',
              iconClass: 'row1-icon',
              url: 'https://www.instagram.com/eswop_eu/'
            },
            {
              icon: require('../../assets/image/eu-home/douyin.png'),
              boxClass: 'row1-box',
              iconClass: 'row1-icon',
              url: 'https://www.tiktok.com/@eswopeu2024'
            },
            {
              icon: require('../../assets/image/eu-home/red-book.png'),
              boxClass: 'row1-box',
              iconClass: 'row1-icon',
              url: 'https://www.xiaohongshu.com/user/profile/619a26280000000010006b6d?xsec_token=ABv-hmYbBy2lhrazR1wi4qNWi4fIGvyC_0m5jHk7B17U8%3D&xsec_source=pc_search'
            },
            
          ]
        },
        {
          title: this.$t('bottom.index.646d71qugz40'),
          icons: [
            {
              icon: require('../../assets/image/eu-home/paypal.png'),
              boxClass: 'row-box',
              iconClass: 'row-icon',
              url: ''
            },
            {
              icon: require('../../assets/image/eu-home/wsd.png'),
              boxClass: 'row-box',
              iconClass: 'row-icon',
              url: ''
            },
            {
              icon: require('../../assets/image/eu-home/visa.png'),
              boxClass: 'row-box',
              iconClass: 'row-icon',
              url: ''
            }
          ]
        },
        {
          title: this.$t('bottom.index.646u51qugz40'),
          icons: [
            {
              icon: require('../../assets/image/eu-home/dpd.png'),
              boxClass: 'row-box',
              iconClass: 'row-icon',
              url: ''
            },
            {
              icon: require('../../assets/image/eu-home/royalmail.png'),
              boxClass: 'row-box',
              iconClass: 'row-icon',
              url: ''
            },
            {
              icon: require('../../assets/image/eu-home/ups.png'),
              boxClass: 'row-box',
              iconClass: 'row-icon',
              url: ''
            },
            {
              icon: require('../../assets/image/eu-home/correos.png'),
              boxClass: 'row-box',
              iconClass: 'row-icon',
              url: ''
            }
          ]
        }
      ],
      bottomDomList: [
        {
          text: this.$t('bottom.index.646u5dqui780'),
          url: 'cookiePriva'
        },
        {
          text: this.$t('bottom.index.646uddqui780'),
          url: 'TermsAndConditions'
        },
        {
          text: this.$t('bottom.index.646u51qui780'),
          url: 'FAQs'
        }
      ]
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen;
      }
    })
  },
  mounted() {},
  methods: {
    handleJumpToPage(url) {
      if (url) {
        if (url.includes('http')) {
          window.open(url);
        } else {
          this.$router.push({name: url});
        }
      }
    }
  }
};
</script>

<style scoped lang="less">
@media (min-width: 981px) {
  .bottom-content {
    width: 100%;

    .pc_bottom-container {
      width: 100%;
      background: #252629;
      .bottom-arrow-box {
        width: 100%;
        position: relative;
        bottom: 2px;
        .bottom-arrow-icon {
          width: 100%;
          flex-shrink: 0;
        }
      }
      .bottom-content-box {
        padding: 80px 0 120px;
        max-width: 1400px;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #252629;
        .bottom-content {
          width: 100%;
          display: flex;
          justify-content: space-between;
          .bottom-content-item {
            width: 380px;
            .subtract-icon {
              width: 40px;
              height: 40px;
              margin-right: 12px;
            }
            .danghuan-logo{
              width: 218px;
              height: 40px;
            }
            .eSwop-icon {
              width: 112px;
              height: 32px;
            }
            .bottom-content-row-box {
              .bottom-content-row-title {
                color: #c7ccd4;
                font-family: 'PingFang SC';
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: 150%;
                margin-bottom: 24px;
              }
              .bottom-content-row {
                display: flex;
                align-items: center;
                margin-bottom: 64px;

                .row1-box {
                  margin-right: 32px;

                  .row1-icon {
                    width: 24px;
                    height: 24px;
                    flex-shrink: 0;
                    cursor: pointer;
                  }
                }
                .row-box {
                  display: flex;
                  // width: 80px;
                  height: 60px;

                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                  margin-right: 40px;
                  .row-icon {
                    // width: 80px;
                    height: 60px;
                  }
                }
              }
            }
            .bottom-content-row-dom-text {
              color: #c7ccd4;
              font-family: 'PingFang SC';
              font-size: 13px;
              font-style: normal;
              font-weight: 400;
              line-height: 160%;
              margin-bottom: 24px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 980px) {
  .bottom-content {
    width: 100%;

    .bottom-container {
      width: 100%;
      background: #252629;
      .bottom-content-box {
        width: calc(100% - 60px);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 120px 30px 26px;
        .bottom-content-item {
          width: 100%;
          margin-bottom: 64px;
          &:nth-child(2){
            border-bottom: 2px solid rgba(235, 235, 235, 0.1);
          }
          .subtract-icon {
            width: 48px;
            height: 48px;
            margin-right: 12px;
          }
          .eSwop-icon {
            width: 144px;
            height: 48px;
          }

          .danghuan-logo{
              width: 218px;
              height: 40px;
            }
          .bottom-content-row-box {
            .bottom-content-row-title {
              color: #c7ccd4;
              font-family: 'PingFang SC';
              font-size: 32px;
              font-style: normal;
              font-weight: 500;
              line-height: 150%;
              margin-bottom: 32px;
            }
            .bottom-content-row {
              display: flex;
              align-items: center;
              margin-bottom: 64px;

              .row1-box {
                margin-right: 48px;

                .row1-icon {
                  width: 32px;
                  height: 32px;
                  flex-shrink: 0;
                }
              }
              .row-box {
                display: flex;
                width: 160px;
                height: 80px;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin-right: 17px;
                .row-icon {
                  width: 160px;
                }
              }
            }
          }
          .bottom-content-row-dom-text {
            color: #c7ccd4;
            font-family: 'PingFang SC';
            font-size: 26px;
            font-style: normal;
            font-weight: 400;
            line-height: 160%;
            margin-bottom: 24px;
          }
        }
      }
    }
  }
}
</style>
